import { capitalize } from '@mui/material'
import dayjs from 'dayjs'
import Decimal from 'decimal.js'
import {addCommas, forexMath, toFixedIfNull, zeroOnUndefined} from '../../../../../../helpers'
import {
	setForexRefreshTrades,
	setRefreshTrade
} from '../../../../../../store/redusers/positions/actions'



export const buildOpenTradeData = (trade, latestBidAsk, userCurrency, tailDigitOfCurrency, marginTrade) => {
	let lotSizeDefault = trade.lotSize
	let thisPnl = trade.openPnl
	let leverage =  parseFloat(trade.leverage)
	let currentPrice = 0
	let pipsDiffer = 0
	let latestRatesBidAsk = latestBidAsk['asset_' + trade.assetId]
	if (!marginTrade){
		if(latestRatesBidAsk !== undefined){
			if (trade.position == 'buy') {
				currentPrice = new Decimal(((latestRatesBidAsk['bid'] === undefined) ? 0 : latestRatesBidAsk['bid']))
				pipsDiffer = forexMath.getPipsDiffer(currentPrice, trade.executionEntryRate)
			} else {
				currentPrice = new Decimal(((latestRatesBidAsk['ask'] === undefined) ? 0 : latestRatesBidAsk['ask']))
				pipsDiffer = forexMath.getPipsDiffer(trade.executionEntryRate, currentPrice)
			}
			let thisMult = forexMath.getMultClient(trade)
			let singlePip = forexMath.getSinglePip(trade.pipDecimalPlaces)
			thisPnl = forexMath.getTradePnl(pipsDiffer, singlePip, trade.pipValueServer,
				leverage, thisMult, trade.stopLossAmount, trade.takeProfitAmount)
		}
	}
	return {
		assetId: trade.assetId,
		asset_class: trade.assetClass,
		asset_id: 'asset_' + trade.assetId,
		asset_name: trade.assetName,
		current_price: forexMath.formatRateForTrade(currentPrice.toString(), trade),
		date: getHumanDateExecutionDate(trade),
		endDateClient: trade.endDateClient,
		executionEntryRate: trade.executionEntryRate,
		fee: zeroOnUndefined(trade.commissionAmount) + ' ' + (userCurrency || 'USD'),
		id: trade.id,
		leverage: trade.leverage,
		lotSize: trade.lotSize,
		openPnl: trade.openPnl,
		pipDecimalPlaces: trade.pipDecimalPlaces,
		pipValueServer: trade.pipValueServer,
		pnl_close:  toFixedIfNull(thisPnl, tailDigitOfCurrency),
		position: trade.position,
		price: parseFloat(forexMath.formatRateForTrade(trade.executionEntryRate, trade)),
		stopLoss: trade.stopLoss,
		stopLossAmount: trade.stopLossAmount,
		stop_loss: +trade.stopLoss === 0 || +trade.stopLoss === 10000000
			? 'SL' : parseFloat(forexMath.formatRateForTrade(trade.stopLoss, trade)),
		swap: addCommas(parseFloat(forexMath.formatSwapForTrade(trade.swap, trade))) + ' ' + (userCurrency || 'USD'),
		takeProfit: trade.takeProfit,
		takeProfitAmount: trade.takeProfitAmount,
		take_profit: +trade.takeProfit === 10000000 || +trade.takeProfit === 0
			? 'TP' : parseFloat(forexMath.formatRateForTrade(trade.takeProfit, trade)),
		trade_size_lots: forexMath.getTradeSizeValueStr(lotSizeDefault, trade.leverage)
			+ ' / ' + trade.leverage,
		type: capitalize(trade.position)
	}
}

export const updateOpenTradeData = (trade, loginUserCurrency, latestBidAsk,
	forexRefreshTrades, userCurrency, tailDigitOfCurrency,
	marginTrade, assetsWithNoPricerData,  dispatch, alert, t ) => {
	let tradePnl = parseFloat(trade.pnl_close)
	let tradeExecutionEntryRate = trade.executionEntryRate
	let currentPrice
	let formattedPrice
	if (tradeExecutionEntryRate == null) {
		tradeExecutionEntryRate = 0
	}
	let leverage = 1
	let thisMult = forexMath.getMultClient(trade)
	if (trade.leverage) {
		leverage = parseFloat(trade.leverage)
	}
	let pipDecimalPlaces = trade.pipDecimalPlaces
	let tradePipValue = trade.pipValueServer
	let singlePip = forexMath.getSinglePip(pipDecimalPlaces)
	let tP = (new Decimal(trade.takeProfit))
	let sL = (new Decimal(trade.stopLoss))
	let nowTimeInSeconds = Math.floor(Date.now() / 1000)
	if (typeof tradePnl == 'undefined' || tradePnl == null || isNaN(tradePnl)) {
		tradePnl = trade.openPnl
	}
	if ((typeof latestBidAsk === 'undefined'
			&& typeof latestBidAsk === 'undefined') ||
		(typeof latestBidAsk !== 'undefined'
			&& typeof latestBidAsk !== 'undefined')) {
		assetsWithNoPricerData[trade.assetId] = nowTimeInSeconds
	}
	if (typeof latestBidAsk === 'undefined'
		&& nowTimeInSeconds > assetsWithNoPricerData[trade.assetId] + 60) {
		tradePnl = trade.openPnl
	}
	if (typeof latestBidAsk != 'undefined') {
		let pipsDiffer
		if (trade.position == 'buy') {
			currentPrice = new Decimal(((latestBidAsk.bid === undefined) ? 0 : latestBidAsk.bid))
			if (forexRefreshTrades[trade.id] === undefined) {
				if (tP.cmp(currentPrice) <= 0 || sL.cmp(currentPrice) >= 0) {
					dispatch(setForexRefreshTrades({tradeId: trade.id, value: true}))
					dispatch(setRefreshTrade(trade.id, alert, t))
				}
			}
			formattedPrice = forexMath.formatRateForTrade(currentPrice.toString(), trade)
			pipsDiffer = forexMath.getPipsDiffer(currentPrice, parseFloat(tradeExecutionEntryRate))
			tradePnl = forexMath.getTradePnl(pipsDiffer, singlePip, tradePipValue,
				leverage, thisMult, trade.stopLossAmount, trade.takeProfitAmount)
		} else {
			currentPrice = new Decimal(((latestBidAsk.ask === undefined) ? 0 : latestBidAsk.ask))
			if (forexRefreshTrades[trade.id] === undefined) {
				if (tP.cmp(currentPrice) >= 0 || sL.cmp(currentPrice) <= 0) {
					dispatch(setForexRefreshTrades({tradeId: trade.id, value: true}))
					dispatch(setRefreshTrade(trade.id, alert, t))
				}
			}
			formattedPrice = forexMath.formatRateForTrade(currentPrice.toString(), trade)
			pipsDiffer = forexMath.getPipsDiffer(parseFloat(tradeExecutionEntryRate), currentPrice)
			tradePnl = forexMath.getTradePnl(pipsDiffer, singlePip, tradePipValue,
				leverage, thisMult, trade.stopLossAmount, trade.takeProfitAmount, marginTrade)
		}
	}
	let tradePnlStr = forexMath.getTradePnlStr(tradePnl, tailDigitOfCurrency)
	return {'current_price': formattedPrice, 'pnl_close': tradePnlStr}
}

export const buildPendingTradeData = (trade) => {
	let currentRate = 'N/A'
	let canceled = false
	if (trade.status !== 'pending') {
		canceled = true
	}
	let pendingDate = ''
	let bid_ask_pending = ' (bid)'
	if (typeof trade.date !== 'undefined' && trade.date !== null) {
		pendingDate = dayjs(trade.date).format('DD.MM.YYYY HH:mm:ss')
	}
	if (trade.orderType == 'buy-stop' || trade.orderType === 'buy-limit') {
		bid_ask_pending = ' (ask)'
	}
	if(trade.status === 'pendingOff'){
		bid_ask_pending=''
	}
	return {
		asset_class: trade.assetClass,
		asset_id: 'asset_' + trade.assetId,
		asset_name: trade.assetName,
		bid_ask_pending,
		canceled,
		date: pendingDate,
		id: trade.id,
		now: currentRate,
		pending: parseFloat(forexMath.formatRateForTrade(trade.executionEntryRate, trade)),
		type: trade.orderType && capitalize(trade.orderType)
	}
}

export const buildCloseTradeData = (trade, userCurrency, tailDigitOfCurrency) => {
	return {
		asset_class: trade.assetClass,
		asset_name: trade.assetName,
		close_date: dayjs(trade.endDate).format('DD.MM.YYYY HH:mm:ss'),
		date: getHumanDateExecutionDate(trade),
		fee: zeroOnUndefined(trade.commissionAmount) + ' ' + (userCurrency || 'USD'),
		id: trade.id,
		open_price: trade.executionEntryRate,
		pnl: toFixedIfNull(trade.openPnl, tailDigitOfCurrency),
		swap: addCommas(parseFloat(forexMath.formatSwapForTrade(trade.swap, trade))) + ' ' + (userCurrency || 'USD'),
		type: trade.position && capitalize(trade.position)
	}
}

export const getHumanDateExecutionDate = (trade) => {
	let humanDateExecutionDate =  dayjs(trade.executionDate).format('DD.MM.YYYY HH:mm:ss')
	let endDateClient
	if (typeof trade.endDateClient !='undefined' && trade.endDateClient !== null) {
		endDateClient = trade.endDateClient
	} else {
		endDateClient = trade.endDate
	}
	if (typeof endDateClient != 'undefined' &&  endDateClient !== null) {
		humanDateExecutionDate = dayjs(endDateClient).format('DD.MM.YYYY HH:mm:ss')
	}
	return humanDateExecutionDate
}

